import type { Bono } from '../types/content'

export const bonos: Bono[] = [
  {
    index: '01',
    emoji: '🧊',
    title: 'Reset Heladera',
    value: '$8.000',
    description:
      'Antes de empezar el sistema, la heladera tiene que estar lista para recibirlo. Este bono te guía en 30 minutos para vaciar, limpiar, reorganizar y etiquetar cada zona de tu heladera. Sistema de rotación incluido para que nunca más se pierda comida ni se venza nada en el fondo del cajón.',
  },
  {
    index: '02',
    emoji: '♻️',
    title: 'Guía Anti Desperdicio',
    value: '$7.000',
    description:
      'Para los días que sobró comida y no sabés qué hacer con ella. Quince combinaciones salvadoras pensadas con lo que ya tenés en casa. Nunca más vas a tirar comida a la basura ni comer lo mismo dos días seguidos.',
  },
  {
    index: '03',
    emoji: '🛒',
    title: 'Kit Compra Inteligente',
    value: '$6.000',
    description:
      'La lista maestra de supermercado organizada por secciones para que la compra semanal dure menos de 30 minutos y no olvides nada. Vas a gastar menos porque sabés exactamente qué comprar y en qué cantidad.',
  },
  {
    index: '04',
    emoji: '🥣',
    title: 'Aderezos y Salsas Base',
    value: '$6.000',
    description:
      'Veinte aderezos saludables que transforman cualquier comida simple en algo que da ganas de comer. Listos en 5 minutos con ingredientes de feria. Este bono solo ya cambia tu relación con la comida del sistema.',
  },
  {
    index: '05',
    emoji: '🗓️',
    title: 'Planificador Semanal Imprimible',
    value: '$5.000',
    description:
      'Una hoja lista para imprimir y pegar en tu heladera. Planificás los 7 días de un vistazo. Nunca más la pregunta de “no sé qué como hoy”. Todo visible, todo claro, todo resuelto.',
  },
  {
    index: '06',
    emoji: '⏱️',
    title: 'Guía Express de 15 Minutos',
    value: '$7.000',
    description:
      'Para los días que no preparaste nada y el tiempo vuela. Diez comidas completas y saludables listas en menos de 15 minutos con lo que ya tenés en casa. Tu red de seguridad para los miércoles de catástrofe.',
  },
]

export const bonosTotalValue = '$39.000 ARS'
